import { Controller } from "@hotwired/stimulus"

// Reloads a named turbo-frame in reaction to a DOM event, debounced so a burst of
// events (e.g. a multi-file upload finishing) coalesces into a single refresh.
// Wire it declaratively, e.g.
//   data-controller="frame-reloader"
//   data-frame-reloader-frame-id-value="media_list"
//   data-action="media-upload:completed@window->frame-reloader#reload"
export default class extends Controller {
  static values = { frameId: String }

  connect() {
    this.timer = null
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  reload() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.timer = null
      const frame = document.getElementById(this.frameIdValue)
      if (!frame) return

      // A frame rendered inline (no `src`) has nothing to fetch on reload(), so
      // point it at the current URL — preserving any active search/filter/sort —
      // the first time; thereafter reload() re-fetches it.
      if (frame.src) {
        frame.reload()
      } else {
        frame.src = window.location.href
      }
    }, 400)
  }
}
